<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <factura-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import FacturaCrud from "./FacturaCrud";
    export default {
        name: "Factura",
        components: {FacturaCrud}
    }
</script>

<style scoped>

</style>

